import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Coverage } from "@/components/site/Coverage";
import { Partners } from "@/components/site/Partners";
import { PlansSection } from "@/components/site/PlansSection";
import { Section } from "@/components/site/Section";
import { PromoPopup } from "@/components/site/PromoPopup";
import { HuggyChat } from "@/components/site/HuggyChat";
import { Reveal, RevealStagger } from "@/components/site/Reveal";
import { useBrand, waLink } from "@/hooks/useSiteContent";
import { testimonials } from "@/content/site";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Contato Internet — Internet fibra óptica com conexão de verdade" },
      {
        name: "description",
        content:
          "Planos de fibra óptica de 500 Mega a 1 Giga com Wi-Fi incluso, +200 canais de TV, instalação grátis e suporte local.",
      },
      { property: "og:title", content: "Contato Internet — Conexão de verdade" },
      {
        property: "og:description",
        content:
          "Planos de fibra óptica de 500 Mega a 1 Giga com Wi-Fi incluso, instalação grátis e suporte local.",
      },
    ],
  }),
  component: Index,
});

function Index() {
  const brand = useBrand();
  const whatsappLink = (m: string) => waLink(brand.whatsapp, m);
  return (
    <>
      <Hero />

      <Reveal variant="fade-up" delay={100}>
        <Services />
      </Reveal>

      <Reveal variant="fade-in" delay={100}>
        <Partners />
      </Reveal>

      <Reveal variant="slide-left" delay={100}>
        <Coverage />
      </Reveal>

      <Reveal variant="fade-up" delay={100}>
        <PlansSection />
      </Reveal>

      <Section eyebrow="Depoimentos" title="O que dizem nossos clientes">
        <RevealStagger className="grid gap-6 md:grid-cols-2" staggerDelay={120}>
          {testimonials.map((t) => (
            <figure key={t.name} className="rounded-3xl border border-border bg-card p-6 sm:p-8">
              <blockquote className="text-base leading-relaxed text-foreground sm:text-lg">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6">
                <span className="block font-extrabold">{t.name}</span>
                <span className="text-sm text-muted-foreground">{t.role}</span>
              </figcaption>
            </figure>
          ))}
        </RevealStagger>
      </Section>

      <section className="bg-secondary/40 pb-12 sm:pb-20">
        <div className="mx-auto max-w-7xl px-5">
          <Reveal variant="fade-up" delay={100}>
            <div className="flex flex-col items-center gap-6 rounded-[2rem] bg-brand-deep px-6 py-10 sm:px-8 sm:py-14 text-center text-brand-deep-foreground">
              <h2 className="max-w-2xl text-2xl sm:text-3xl md:text-4xl">
                Pronto para trocar de internet sem dor de cabeça?
              </h2>
              <p className="max-w-xl text-sm text-brand-sky sm:text-base">
                Fale com a gente pelo WhatsApp e descubra em segundos se sua rua já tem fibra
                Contato.
              </p>
              <a
                href={whatsappLink("Olá! Quero saber se minha região tem cobertura da Contato.")}
                target="_blank"
                rel="noreferrer"
                className="rounded-full bg-brand-yellow px-7 py-3 text-xs sm:px-8 sm:py-3.5 sm:text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground transition-transform hover:-translate-y-0.5"
              >
                Verificar cobertura
              </a>
            </div>
          </Reveal>
        </div>
      </section>
      <PromoPopup />
      <HuggyChat />
    </>
  );
}
